export const SideBar = ({ children }: { children: React.ReactNode }) => (
  <div className="fixed left-10 sm:left-20 top-14 bottom-0 bg-sidebar-menu border-r border-r-sidebar-menu-border z-10 w-[calc(100vw-5rem)] sm:w-md max-w-lg overflow-y-auto">
    {children}
  </div>
);
